import React from 'react';
import { useNavigate } from 'react-router-dom';
import { getUser, clearTokens } from '../api';
import { MessageSquare, Settings, Shield, Power } from 'lucide-react';
import '../pages/Chat.css';

export default function AppLayout({ children }) {
  const navigate = useNavigate();
  const user = getUser();

  const handleLogout = async () => {
    clearTokens();
    navigate('/login');
  };

  const initials = user ? user.name.split(' ').map(w => w[0]).join('').substring(0, 2).toUpperCase() : '';

  return (
    <div className="app-layout">
      <div className="app-layout-sidebar">
        <div className="app-layout-avatar">{initials}</div>
        <div className="app-layout-menu">
          <button className="app-layout-btn" onClick={() => navigate('/')}><MessageSquare size={20} /> <span>Чат</span></button>
          <button className="app-layout-btn" onClick={() => navigate('/settings')}><Settings size={20} /> <span>Настройки</span></button>
          {user && user.role === 'admin' && (
            <button className="app-layout-btn" onClick={() => navigate('/admin')}><Shield size={20} /> <span>Панель</span></button>
          )}
        </div>
        <div className="app-layout-bottom">
          <button className="app-layout-btn logout" onClick={handleLogout}><Power size={20} /> <span>Выйти</span></button>
        </div>
      </div>
      <div className="app-layout-content">
        {children}
      </div>
    </div>
  );
}
